import { render, staticRenderFns } from "./ProductosListMobile.vue?vue&type=template&id=530d3164&scoped=true&"
import script from "./ProductosListMobile.vue?vue&type=script&lang=js&"
export * from "./ProductosListMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductosListMobile.vue?vue&type=style&index=0&id=530d3164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d3164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
